import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="time-ago"
export default class extends Controller {
    static values = {
        timestamp: String,
        refreshInterval: { type: Number, default: 60000 } // Update every minute
    }

    connect() {
        this.update()
        this.startTimer()
    }

    disconnect() {
        this.stopTimer()
    }

    startTimer() {
        this.timer = setInterval(() => {
            this.update()
        }, this.refreshIntervalValue)
    }

    stopTimer() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }

    update() {
        const date = new Date(this.timestampValue)
        const now = new Date()
        const seconds = Math.floor((now - date) / 1000)

        let interval = seconds / 31536000
        if (interval > 1) {
            return this.element.textContent = Math.floor(interval) + " years ago"
        }

        interval = seconds / 2592000
        if (interval > 1) {
            return this.element.textContent = Math.floor(interval) + " months ago"
        }

        interval = seconds / 86400
        if (interval > 1) {
            return this.element.textContent = Math.floor(interval) + " days ago"
        }

        interval = seconds / 3600
        if (interval > 1) {
            return this.element.textContent = Math.floor(interval) + " hours ago"
        }

        interval = seconds / 60
        if (interval > 1) {
            return this.element.textContent = Math.floor(interval) + " minutes ago"
        }

        return this.element.textContent = "just now"
    }
}
